"use client";

import {
  ChevronLeft,
  ChevronRight,
  Clock,
  ScreenShare,
  Webcam,
} from "lucide-react";

import { BsFilePerson } from "react-icons/bs";
import { Button } from "@/components/ui/button";
import { ProjectInfo } from "@/types";
import { cn } from "@/lib/utils";
import { useDataContext } from "@/app/_context";
import { useTheme } from "next-themes";

// Chevron Left Component
export const ChevronLeftComponent = () => {
  const { startPreviousSession, currentSessionIndex } = useDataContext();
  const { theme } = useTheme();

  return (
    <>
      {currentSessionIndex > 0 && <ChevronLeft className="WidgetLeftChevron" />}
      <ChevronLeft
        style={{ cursor: currentSessionIndex == 0 ? "default" : "pointer" }}
        onClick={() => startPreviousSession()}
        className="arrows"
      />
    </>
  );
};

// Chevron Right Component
export const ChevronRightComponent = () => {
  const { startNextSession, currentPlaylist, currentSessionIndex } =
    useDataContext();
  const { theme } = useTheme();

  return currentSessionIndex + 1 < currentPlaylist?.length ? (
    <ChevronRight className="WidgetRightChevron" />
  ) : (
    <ChevronRight
      onClick={() => startNextSession()}
      className="arrows"
      color={theme === "dark" ? "white" : "gray"}
    />
  );
};

export const PortalFooter = ({
  meta,
  mini,
  pip,
  reelLength,
}: {
  meta: ProjectInfo;
  mini?: boolean;
  pip?: boolean;
  /** Set when the reel is narrowed to a story; otherwise the project's count. */
  reelLength?: number;
}) => {
  const { currentSessionIndex: currentIndex } = useDataContext();
  const total = reelLength ?? meta?.highlights;
  return (
    <div
      className={cn(
        pip ? "py-0.5" : "py-2",
        "holder z-10 absolute inset-0 h-full w-full  left-0 bottom-0 flex items-center",
      )}
    >
      <div className="researchDuration [&>span>svg]:w-3 *:flex *:bg-white/10 *:rounded-full *:px-3 *:text-xs  gap-3 pl-3 flex h-full w-full  *:items-center *:md:gap-3 *:gap-2">
        <span className="hidden! sm:flex!">
          <Clock className="text-accent dark:text-yellow-400" />
          <span> {meta?.minutes}m</span>
        </span>
        <span>
          {meta?.events}

          <ScreenShare className="text-accent dark:text-yellow-400" />
        </span>
        <span>
          <span> {meta?.highlights}</span>

          <Webcam className="text-accent dark:text-yellow-400" />
        </span>
      </div>
      {!mini && !pip && (
        <Button
          variant={"secondary"}
          className="!h-6 !tracking-loose w-full !text-sm !p-2 mx-3 -ml-3"
        >
          See Research
        </Button>
      )}
      {!mini && (
        <div className="flex gap-1 mr-2 text-xs">
          {total > currentIndex ? (
            <>
              <span>{currentIndex + 1}</span>
              <span>/</span>
              <span>{total}</span>
            </>
          ) : (
            <div
              className="widgetPlaylistNumber"
              // data-tip="Video Bio"
              // data-for="NowPlayingTooltip"
            >
              <span>
                <BsFilePerson style={{ margin: "0 0.4em" }} />
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
